import React from 'react';
import { NetworkInsights } from '@frontend/gql/social/graphql';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@frontend/shadcn/components/ui/table';

interface NetworkMetricsTableProps {
  data?: NetworkInsights | null;
  socialDataReconciliation?: boolean;
}

export const NetworkMetricsTable = ({ data, socialDataReconciliation }: NetworkMetricsTableProps) => {
  return (
    <Table wrapperProps={{ className: 'h-auto' }}>
      <TableHeader>
        <TableRow className="border-t">
          <TableHead className="text-left px-4 py-2 border-r border-t">Metric</TableHead>
          <TableHead className="text-right px-4 py-2 border-t">Value</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        <TableRow>
          <TableCell className="text-left border-r">Posts Created</TableCell>
          <TableCell className="text-right">{data?.postsCreated?.toLocaleString() ?? '0'}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell className="text-left border-r">Potential Reach</TableCell>
          <TableCell className="text-right">{data?.potentialReach?.toLocaleString() ?? '0'}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell className="text-left border-r">Impression</TableCell>
          <TableCell className="text-right">{data?.impressions?.toLocaleString() ?? '0'}</TableCell>
        </TableRow>
        {socialDataReconciliation && (
          <TableRow>
            <TableCell className="text-left border-r">Organic Impressions</TableCell>
            <TableCell className="text-right">{data?.organicImpressions?.toLocaleString() ?? '0'}</TableCell>
          </TableRow>
        )}
        {socialDataReconciliation && (
          <TableRow>
            <TableCell className="text-left border-r">Paid Impressions</TableCell>
            <TableCell className="text-right">{data?.paidImpressions?.toLocaleString() ?? '0'}</TableCell>
          </TableRow>
        )}
        <TableRow>
          <TableCell className="text-left border-r">Engagement</TableCell>
          <TableCell className="text-right">{data?.engagements?.toLocaleString() ?? '0'}</TableCell>
        </TableRow>
        {socialDataReconciliation && (
          <TableRow>
            <TableCell className="text-left border-r">Organic Engagements</TableCell>
            <TableCell className="text-right">{data?.organicEngagements?.toLocaleString() ?? '0'}</TableCell>
          </TableRow>
        )}
        {socialDataReconciliation && (
          <TableRow>
            <TableCell className="text-left border-r">Paid Engagements</TableCell>
            <TableCell className="text-right">{data?.paidEngagements?.toLocaleString() ?? '0'}</TableCell>
          </TableRow>
        )}
        <TableRow>
          <TableCell className="text-left border-r border-b-0">Engagement Rate</TableCell>
          <TableCell className="text-right border-b-0">
            {data?.engagementRate ? `${(data.engagementRate * 100).toFixed(2)}%` : '0%'}
          </TableCell>
        </TableRow>
      </TableBody>
    </Table>
  );
};
